import { render, staticRenderFns } from "./dedicate.vue?vue&type=template&id=b2fc0fac&scoped=true&"
import script from "./dedicate.vue?vue&type=script&lang=js&"
export * from "./dedicate.vue?vue&type=script&lang=js&"
import style0 from "./dedicate.vue?vue&type=style&index=0&id=b2fc0fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fc0fac",
  null
  
)

export default component.exports